export default __webpack_public_path__ + "static/media/search-icon-v2.1a5b8ca4.svg";